import * as React from 'react'

import { relevantYear, } from './shared'

import { arrowPointingRightIcon } from '../../../Shared/index'
import BulkArchiveClassesModal from '../shared/bulk_archive_classes_modal'

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/pages/dashboard/bulk_archive_close_icon.svg`
const illustrationSrc = `${window.postbuildEnv.CDN_URL}/images/pages/dashboard/bulk_archive_illustration.svg`

const BulkArchiveClassroomsCard = ({ classrooms, onSuccess, userId, }) => {
  const currentRelevantYear = relevantYear()
  const bulkArchiveLocalStorageKey = `${currentRelevantYear}BulkArchiveCardClosedForUser${userId}`

  const [bulkArchiveCardClosedForRelevantYear, setBulkArchiveCardClosedForRelevantYear] = React.useState(window.localStorage.getItem(bulkArchiveLocalStorageKey))
  const [modalIsOpen, setModalIsOpen] = React.useState(false)

  function handleCloseBulkArchiveCard() {
    window.localStorage.setItem(bulkArchiveLocalStorageKey, 'true')
    setBulkArchiveCardClosedForRelevantYear(true)
  }

  const handleOpenModal = () => {
    setModalIsOpen(true)
  }

  const handleCloseModal = () => {
    setModalIsOpen(false)
  }

  function handleSuccess(snackbarCopy) {
    handleCloseModal()
    handleCloseBulkArchiveCard()
    onSuccess(snackbarCopy)
  }

  const classesCreatedLastSchoolYear = classrooms.filter(c => {
    const createdAt = new Date(c.created_at)
    return new Date(`July 1, ${currentRelevantYear}`) > createdAt
  })

  if (!classesCreatedLastSchoolYear.length || bulkArchiveCardClosedForRelevantYear) { return <span /> }

  return (
    <React.Fragment>
      {modalIsOpen && <BulkArchiveClassesModal classes={classesCreatedLastSchoolYear} onCloseModal={handleCloseModal} onSuccess={handleSuccess} /> }
      <section className="bulk-archive-classes-card">
        <div>
          <div className="badge-section">
            <span className="title-tag">HELPFUL TIP</span>
          </div>
          <h2>Start of a new school year?</h2>
          <p>Quickly archive last year&#39;s classes.</p>
          <div className="link-section">
            <button className="interactive-wrapper" onClick={handleOpenModal} type="button"><span>Archive Classes</span><img alt={arrowPointingRightIcon.alt} src={arrowPointingRightIcon.src} /></button>
          </div>
        </div>
        <button aria-label="Hide card until next school year" className="interactive-wrapper close-button focus-on-light" onClick={handleCloseBulkArchiveCard} type="button"><img alt="" src={closeIconSrc} /></button>
        <img alt="" className="illustration" src={illustrationSrc} />
      </section>
    </React.Fragment>
  )
}

export default BulkArchiveClassroomsCard
